export default __webpack_public_path__ + "static/media/greeting15.1fbb3905.png";